<template>
  <div class="main">
    <el-carousel :interval="5000" arrow="always" :height="height">
      <el-carousel-item v-for="item in bg_images" :key="item">
        <img :src="item" class="carousel-img">
      </el-carousel-item>
    </el-carousel>
    <div class="index-main">
      <div class="content-top">
        <p>
          <img src="../assets/title_products.png" width="150px" />
        </p>
        <ul id="list">
            <li>
              <a class="pic" href="http://www.zhonghuihaotai.com/#/website/product_service"><img  src="../assets/bg_01.png"  alt="" /></a></li>
            <li>
              <a class="pic" href="http://www.zhonghuihaotai.com/#/website/product_service"><img src="../assets/bg_2.png" alt="" /></a></li>
            <li><a class="pic" href="http://www.zhonghuihaotai.com/#/website/product_service"><img src="../assets/bg_3.png" 
               alt="" /></a></li>
        </ul>
        <br style="clear:both;" />
      </div>
      <!-- 轮播图 -->
	 

      <!-- <div class="content-cooper" >
        <p>
          <img src="../assets/title_enterprises.png" width="150px" style="margin-top:45px" />
        </p>
        <div class="newsCen_swiper1" >
          <swiper :options="swiperOption" ref="mySwiper" @touchmove.native="stopPlay" @touchend.native="play" >
              <swiper-slide>
                  <div class="x-cooper" :class="activeNewsIndex==1?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(1)">
                      <a class="pic" target="_blank" href=""><img  src="../assets/chuyang.png" alt="" /></a>
                  </div>
                  <div class="x-cooper" :class="activeNewsIndex==2?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(2)">
                   <a class="pic" target="_blank" href="http://www.lcslj.com/"><img src="../assets/liangchu.png" alt="" /></a>
                  </div>
              </swiper-slide> 
                <swiper-slide>
                  <div class="x-cooper" :class="activeNewsIndex==3?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(1)">
                      <a class="pic" target="_blank" href="http://www.qxhfood.com.cn/"><img  src="../assets/qianxihe.png" alt="" /></a>
                  </div>
                  <div class="x-cooper" :class="activeNewsIndex==16?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(2)">
                   <a class="pic" target="_blank" href="http://www.shsnscy.com/"><img src="../assets/shennongshi.png" alt="" /></a>
                  </div>
              </swiper-slide> 
              <swiper-slide>
                  <div class="x-cooper" :class="activeNewsIndex==4?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(4)">
                      <a class="pic" target="_blank" href="http://www.jingebm.com/"><img  src="../assets/bg_sh.png" alt="" /></a>
                  </div>
                  <div class="x-cooper" :class="activeNewsIndex==5?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(5)">
                   <a class="pic" target="_blank" href="https://www.aramark.cn/"><img src="../assets/bg_aima.png" alt="" /></a>
                  </div>
              </swiper-slide> 
              <swiper-slide>
                  <div class="x-cooper" :class="activeNewsIndex==6?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(6)">
                      <a class="pic" target="_blank" href="http://www.kangou.cn"><img src="../assets/bg_kangou.png" alt="" /></a>
                  </div>
                  <div class="x-cooper" :class="activeNewsIndex==7?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(7)">
                      <a class="pic" target="_blank" href="http://www.gzxyh.com/"><img src="../assets/databg.png" alt="" /></a>
                  </div>
              </swiper-slide>
              <swiper-slide>
                  <div class="x-cooper" :class="activeNewsIndex==8?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(8)">
                      <a class="pic" target="_blank" href="http://www.hot-spot.com.cn/"><img src="../assets/bg-hetebao.png" alt="" /></a>
                    </div>
                    <div class="x-cooper" :class="activeNewsIndex==9?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(9)">
                      <a class="pic" target="_blank" href="http://www.yuezhenxiaochu.com/"><img src="../assets/bg-yuezhenxiaochu.png" alt="" /></a>
                    </div>
              </swiper-slide>
              <swiper-slide>
                  <div class="x-cooper" :class="activeNewsIndex==10?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(10)">
                      <a class="pic" target="_blank" href="http://www.shlscy.com/index.asp"><img src="../assets/longshen.jpg" alt="" /></a>
                    </div>
                    <div class="x-cooper" :class="activeNewsIndex==11?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(11)">
                      <a class="pic" target="_blank" href="http://zhendatuanshan.com/"><img src="../assets/zhenda.jpg" alt="" /></a>
                    </div>
              </swiper-slide> 
              <swiper-slide>
                  <div class="x-cooper" :class="activeNewsIndex==12?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(12)">
                      <a class="pic" target="_blank" href="https://www.quicklygroup.com.cn/"><img src="../assets/kuaikeli.jpg" alt="" /></a>
                    </div>
                    <div class="x-cooper" :class="activeNewsIndex==13?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(13)">
                      <a class="pic" target="_blank" href="http://www.debo-cn.com/"><img src="../assets/dengbao.jpg" alt="" /></a>
                    </div>
               </swiper-slide>
              <swiper-slide>
                  <div class="x-cooper" :class="activeNewsIndex==14?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(14)">
                      <a class="pic" target="_blank" href="	https://www.zsxtc.com/"><img src="../assets/zhongshan.jpg" alt="" /></a>
                  </div>
                  <div class="x-cooper" :class="activeNewsIndex==15?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(15)">
                      <a class="pic" target="_blank" href="https://www.tuanshan365.com/"><img src="../assets/lixinniannian.jpg" alt="" /></a>
                  </div>
              </swiper-slide>
      
              <div class="swiper-pagination" slot="pagination"></div>
              <!-- <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div> -->
        <!-- </swiper>  
       
      </div> -->
           
           
            
        <!-- <br style="clear:both;" />
        <div style="text-align:center;height:100px">
          <a href="http://zhonghuihaotai.com/#/website/cooperation_case" style="text-decoration:none;">
            <p style="background-color:white;display:inline-block; width:100px; height:35px;border: 1px solid #E9E9EA;color: #313233;font-size:15px;line-height:2.3;margin-top:35px">
              查看更多
            </p>
          </a>
        </div>
      </div> -->
      <div class="content-cb"  >
        <p style="margin-top:0px">
          <img src="../assets/title_cb2.png" width="200px" style="margin-top:45px" />
        </p>
        <el-carousel :interval="5000" arrow="always" class="cb-carousel" style="text-align:center">
          <el-carousel-item v-for="item in cb_images" :key="item">
            <div class="cb-img-box">
            <img :src="item" class="cb_carousel-img" style="max-width:85%">
            </div>
          </el-carousel-item>
          <br style="clear:both;" />
        </el-carousel>
        <br style="clear:both;" />
      </div>
      <div class="content-media">
        <p style="margin-top:0px;text-align:center">
          <img src="../assets/title_nc.png" width="150px" style="margin-top:45px" />
        </p>
        <ul id="list">
          <li v-for="(item,index) in related_news">
            <div class="media-div" :class="activeNewsIndex==index?'is-active':''" @mouseleave="onMouseLeaveNews"  @mouseenter="onMouseEnterNews(index)" >
              <a class="pic" :href="'#/website/news_detail?id='+item.id"><img :src="item.image_url" alt="" /></a>
              <p class="title">{{item.short_title}}</p>
              <p class="desc">{{item.short_desc}}</p>
            </div>  
          </li>
        </ul>
        <br style="clear:both;" />
        <div style="text-align:center;height:100px">
          <a href="http://www.zhonghuihaotai.com/#/website/news" style="text-decoration:none;">
          <p style="background-color:white;display:inline-block; width:100px; height:35px;border: 1px solid #E9E9EA;color: #313233;font-size:15px;line-height:2.3;margin-top:35px">
            查看更多
          </p>
          </a>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script >
import axios from 'axios';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
export default {
  name: 'index',
  components: { 
	swiper, 
      swiperSlide, 
},
  data () {
    return {
      // require('../assets/bg_banner2.png'),
      bg_images: [require('../assets/bg_banner.jpeg')],
      cb_images: [require('../assets/logo_jt_5.png'),require('../assets/logo_jt_6.png'),
        require('../assets/logo_jt.png'),require('../assets/logo_jt_1.png'),
        require('../assets/logo_jt_2.png'),require('../assets/logo_jt_3.png'),
        require('../assets/logo_jt_4.png'),
      ],
      headerFixed:true,
      //banners: [ '/1.jpg', '/2.jpg', '/3.jpg' ],
      bannert:'/bg_banner.jpeg',
      height:"600px",
      cb_height:"400px",
      cb_carousel_height:"300px",
      horizontal:false,
      vertical:true,
      menuDisplay:'none',
      activeIndex:"1",
      related_news:[],
      isActive1:false,
      isActive2:false,
      isActive3:false,
      isActive4:false,
	  activeNewsIndex:-1,
      swiperOption: {
            direction: 'horizontal',
            height : window.innerHeight,
            spaceBetween: 0,
            slidesPerView:4,
            // centeredSlides: true,
            loop:false,
            // loopAdditionalSlides:3,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.swiper-pagination',
                direction: 'orizontal',
                clickable: true
            },
            // navigation: {
            //   prevEl: '.swiper-button-next',
            //     nextEl: '.swiper-button-prev'
            // }
        },
     
	  
    }
  },
  methods: {
    onMouseEnter(val) {
      console.log(">>>>>>>V>V>V>>VV>",this.$el)
      if (val == 1) {
        this.isActive1 = true;
        this.isActive2 = false;
        this.isActive3 = false;
        this.isActive4 = false;
      } else if (val==2) {
        this.isActive1 = false;
        this.isActive2 = true;
        this.isActive3 = false;
        this.isActive4 = false;
      } else if (val == 3) {
        this.isActive1 = false;
        this.isActive2 = false;
        this.isActive3 = true;
        this.isActive4 = false;
      } else if (val == 4) {
        this.isActive1 = false;
        this.isActive2 = false;
        this.isActive3 = false;
        this.isActive4 = true;
      }
    },
    onMouseLeave() {
      this.isActive1 = false;
      this.isActive2 = false;
      this.isActive3 = false;
      this.isActive4 = false;
    },

    onMouseLeaveNews() {
      this.activeNewsIndex = -1;
    },

    onMouseEnterNews(val) {

      this.activeNewsIndex = val;
      console.log(this.activeNewsIndex,"<<<<<<")
    },
    onResize(){
      var width = document.documentElement.clientWidth;
      console.log(width);
      this.setCarouselHeight(width)
      this.setHeaderLayout(width)
    },
    setHeaderLayout(width){
      var cb_c_h = "340px";
      if (width <=1200) {
        this.vertical=true;
        this.horizontal=false;

      } else {
        this.horizontal=true;
        this.vertical=false;
      }

      if (width >= 1320) {
        this.cb_carousel_height="380px";
      } else if (width <1320) {
        this.cb_carousel_height="340px";
      }
    },
    setCarouselHeight(width){
      this.height = (width / 2.18).toString()+"px";
      this.cb_height = (width / 3).toString()+"px";
      // this.cb_carousel_height = (width /3)* (3/4).toString() + "px";
    },
    handleOpen(index, path){
      console.log(index, path)
    },

    handleClose(index, path){
      console.log(index, path)
    },
    handlerClick(){
      console.log("wft")
	},
  stopPlay() {
    this.mySwiper.autoplay.stop();    // 当手指触摸时停止自动播放
     },
     play() {
       this.mySwiper.autoplay.start();   // 当手指离开时开始自动播放
     }
    //初始化swiper插件
    // initSwiper(){
    //   var swiper = new Swiper('.swiper-container', {
    //   slidesPerView: 3,
    //   spaceBetween: 30,
    //   pagination: {
    //     el: '.swiper-pagination',
    //     clickable: true,
    //   },
    // });
//   },
},
  mounted(){
    this.onResize();
    window.addEventListener('resize', this.onResize);
    console.log(">>>>>>index wft")
    axios.get(this.base+`/rest/account/api/related_news`, {params:{id:this.id, count:3}}).then(res => {
		if (res.data.code == 200) {
			this.related_news = res.data.data.items;
		}
		});
		

  },

	computed:{
    mySwiper(){
    		return this.$refs.mySwiper.swiper
    	}
  },
 
}
</script>

<style >
#app {
  position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
    left: 0px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;
  color: #2c3e50;
  margin-top: 0px;*/
}
/* 头部导航 */
/*header{z-index: 1000;transition: all 0.5s ease;   background-color: #fff;  }
header.header-fixed{position: fixed;top: 0;left: 0;right: 0;}
header .el-menu-demo{padding-left: 300px!important;}*/
.carousel-img {
  width: 100%;
  height: 100%;
}
.content-top p{
    text-align: center;
}
.content-top {
  margin-top: 60px;
}
/*.content-cooper {
  background-color: #F4F5F6;
  margin-top: 40px;
  padding-bottom: 30px;
}
.content-cooper p{
  text-align: center;
}
*/



/* .x-cooper img{
  display: block;
  margin-bottom: 10px;
    margin-right: 10px;
} */
.content-media {
  background-color: #F4F5F6;
  /*margin-top: 40px;*/
  /*padding-bottom: 30px;*/
}

.title_img{
  text-align: center;
}

.content-media .title{
  text-align: left;
  padding-left: 10px;
  font-size: 16px;
  font-family: "Microsoft Yahei";
  color: #333;
}
.content-media .desc {
  font-size: 14px;
  color: #999;
  padding-left: 8px;
}
.media-div {
  /**/
  background-color: #fff;
  border: 1px solid #def0fd;
 /* 
  */
}
.x-cooper{
border:1px solid transparent;
margin-bottom: 10px;
    margin-right: 10px;
}
.media-div.is-active ,.x-cooper.is-active{
  border: 1px solid #83C0FB;
  box-shadow:0px 0px  10px 1px rgba(168,168,168,0.5);
  -moz-box-shadow:0px 0px  10px 1px rgba(168,168,168,0.5);
  -webkit-box-shadow:0px 0px  10px 1px rgba(168,168,168,0.5);
}

/*.content-top li {
  margin:7px;
 padding:5px;
 float:left;
 width:150px;
 height:190px;
 display: block;
 list-style:none;
}*/
#list {
 /* padding:0px;
 margin-left: 9%;
 margin-right: 2%;
 padding-top: 15px; */
 padding:0;margin:0;
 justify-content: center;
    display: flex;
}
#list li{float:left;width:29%;height: auto;padding:6px;list-style:none;}
#list li .pic{display:block;width:auto;margin:0 auto;}
#list li .pic img{width:100%;height:100%;}


.cooper-list {
 /* padding:0px;
 margin-left: 9%;
 margin-right: 2%;
 padding-top: 15px; */
 /* padding: 0;
    margin: 0;
 display: flex;
    flex-wrap: wrap;
    justify-content: center; */
}
/* .cooper-list li{float:left;width:24%;height: auto;padding:6px;list-style:none;}
.cooper-list li .pic{display:block;width:auto;margin:0 auto;}
.cooper-list li .pic img{width:100%;height:100%;} */


.footer {
  background-color: #252425;
  height: 200px;
  margin-top: 0px;
}
.footer p{
  color: white;
  font-size: 12px;
}
.footer_one {
  /*padding-top: 50px;*/
  float: right;
  padding-top: 43px
}
.footer_two{
  padding-top: 43px;
}
.footer_three{
  padding-top: 43px;
}
.copyright {
  background-color: #212121;
  text-align: center;
}
.copyright p{
  color: #888686;
  margin-top: 0px;
}
.carousel-img { max-width: 100%;width: 100%;-ms-interpolation-mode: bicubic;}

.vertical-style {
    width: 80px;
    float: right;
    padding-right: 0px;
}
/*.vertical-style .el-menu{
  right: 0px;
}*/
/*.vertical-style li{
  text-align: left;
}*/
.el-icon-arrow-down {
  display: none!important;
}
.el-submenu__title {
  border-bottom: 0px!important;
}
@media screen and (max-width: 800px) {
  #list {
     padding:0px;
     margin-left: 2px;
     margin-right: 0px;
     padding-top: 15px;
    }
  #list li {
    display: inline;
    float: left;
    width: 29.9%;
  }


   /* .cooper-list {
     padding:0px;
     margin-left: 2px;
     margin-right: 0px;
     padding-top: 15px;
    }
  .cooper-list li {
    display: inline;
    float: left;
    width: 20%;
  } */

}

.cb_list ul{
    width: 50%;
    text-decoration: none;
    list-style-type: none;
    margin: 0;
    border: 0;
    padding: 0;
    font-style: normal;
    color: #323232;
    box-sizing: border-box;
    -moz-box-sizing:border-box; /* Firefox */
    -webkit-box-sizing:border-box; /* Safari */
}

.cb_list img {
  width:100%;
  height:100%;
}
.cb_list>li{
    float: left;
    width: 23%;
    text-align: center;
    /*border: 1px solid #ccc;*/
    /*height: 50%;*/
    /*padding-top: 10%;*/
    margin-left: 1%;
    margin-top: 1%;
    position: relative;
    list-style:none;
}
.cb_list>li>div{
    height: auto;
    /*position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #09BE07;*/
}
.cb_list>li>div>span{
    display: inline-block;
    margin-top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}

.content-cb {
  background: url(../assets/bg_cb.png) no-repeat 0px -1px;
  min-height: 300px;
  background-color: #F4F5F6;
  /*background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center top;ß
  background-attachment: fixed;*/
  background-repeat: no-repeat; 
  background-attachment:fixed; 
  background-size: cover; 
  -webkit-background-size: cover;/* 兼容Webkit内核浏览器如Chrome和Safari */ 
  -o-background-size: cover;/* 兼容Opera */ 
  zoom: 1; 
}
.content-cb p{
  text-align: center;
}


.content-cb img {
  max-width:100%;
}

@media screen and (min-width: 1400px) {
    .cb-carousel .el-carousel__container{
        height: 380px;
    }
    /* .cooper-list li {
        display: inline;
        float: left;
        width: 22%;
    } */
}
@media screen and (min-width: 1349px) and (max-width: 1399px) {
    .cb-carousel .el-carousel__container{
        height: 350px;
    }
    /* .cooper-list li {
        display: inline;
        float: left;
        width: 22%;
      } */
}
@media screen and (max-width: 1348px) and (min-width: 1000px) {
/*  .cb-img-box {
      padding-top: 4%;
    }*/
    .cb-carousel .el-carousel__container{
        height: 350px;
    }
    /* .cooper-list li {
        display: inline;
        float: left;
        width: 20%;
      } */
}

@media screen and (max-width: 500px) and (min-width: 0px) {
    .content-cb {
      height: 250px
    }
    .cb-carousel .el-carousel__container{
        height: 170px;
    }
    .cb-img-box {
      padding-top: 4%;
    }
    /* .cooper-list li {
        display: inline;
        float: left;
        width: 20%;
      } */
}

@media screen and (max-width: 1000px) and (min-width: 801px) {
    /* .cooper-list li {
        display: inline;
        float: left;
        width: 22%;
      } */
    
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    /* background-color: #99a9bf; */
  }
  
  .el-carousel__item:nth-child(2n+1) {
    /* background-color: #d3dce6; */
  }
  .poster{
        /* background: url(./../assets/img/pg1-bg.png); */
        width: 100%; 
        height: 100%; 
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        zoom: 1; 
    }  
    .swiper-container {
        width: 100%;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
        
    }
    .newsCen_swiper1{
        /* position: fixed; */
        z-index: 1;
        overflow: hidden;
        width: 90%;
        height: 100%; 
        color:red;
        margin-top:200px;
        margin:0 auto;
        position: relative;
     } 
     .x-cooper img{
         width: 100%;
         height: 100%;
     }
     .x-cooper {
    border: 1px solid transparent;
    margin-bottom: 10px;
    margin-right: 10px;
}
.x-cooper.is-active{
    margin-bottom: 10px;
    margin-right: 10px;
  border: 1px solid #83C0FB;
  box-shadow:0px 0px  10px 1px rgba(168,168,168,0.5);
  -moz-box-shadow:0px 0px  10px 1px rgba(168,168,168,0.5);
  -webkit-box-shadow:0px 0px  10px 1px rgba(168,168,168,0.5);
}
.newsCen_swiper1>.swiper-container-horizontal .swiper-pagination-bullets{
    bottom: 34px;
}
.swiper_btn{
      width: 20px;
      height: 20px;
      background-size: contain;
    }
    .newsCen_swiper1 .swiper-pagination-bullet{
    width: 29px;
    height: 4px;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    /* opacity: 0.2; */
    border-radius: 0;
  }  
  .newsCen_swiper1 .swiper-pagination-bullet-active{
    background: #007aff;

  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue